module.exports = __webpack_public_path__ + "img/set_up_check.9e298c48.svg";